import { useEffect, useState } from 'react';

/**
 * /impersonate#token=<jwt>
 * Master admin lands here in a new tab after clicking "View As" on a user.
 * We stash the impersonation token in localStorage under a dedicated key
 * (isolated from the admin's own token in this window) and hard-redirect
 * to the target user's home route. AuthContext reads `token` on mount,
 * so we swap it before the app boots.
 */
export default function ImpersonatePage() {
  const [msg, setMsg] = useState('Preparing view…');

  useEffect(() => {
    const raw = window.location.hash || '';
    const match = raw.match(/token=([^&]+)/);
    if (!match) {
      setMsg('Missing impersonation token. Close this tab and try again from the User Manager.');
      return;
    }
    const token = decodeURIComponent(match[1]);
    // Store in sessionStorage (per-tab) so the admin's original tab keeps
    // its own localStorage.token intact. AuthContext prefers sessionStorage.
    sessionStorage.setItem('token', token);
    sessionStorage.removeItem('clerk_login_reminder_shown');
    setMsg('Opening dashboard…');
    // Hard reload to boot the app under the new token.
    window.location.replace('/');
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white">
      <div className="text-center space-y-3" data-testid="impersonate-msg">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400 mx-auto" />
        <p className="text-sm">{msg}</p>
      </div>
    </div>
  );
}
